import type { User } from "@eai-toolkit/client";

import {
  type BaseQueryState,
  dehydrateQueryStateToStringBase,
  hydrateQueryStateFromStringBase,
} from "../utils/queryStateUtils";

export type UsersQueryState = BaseQueryState<User>;

const DEFAULT_USER_SORT: UsersQueryState["query"]["sort"] = {
  fieldName: "fullName",
  direction: "asc",
};

export function hydrateUsersQueryStateFromString(
  searchString: string,
): UsersQueryState {
  return hydrateQueryStateFromStringBase<User>(searchString, {
    defaultSort: DEFAULT_USER_SORT,
    defaultLimit: 10,
  });
}

export function dehydrateUsersQueryStateToString(
  queryState: UsersQueryState,
): string {
  return dehydrateQueryStateToStringBase<User>(queryState);
}
